import {Component, Input, OnInit} from "@angular/core";
import {DialogService} from '../../../../../ng2-bootstrap-modal/dialog.service';
import {UserSubscription, UserSubscriptionType} from "../../../../user/user-subscription";
import {Router} from "@angular/router";
import {Utils} from "../../../utils/utils";
import {DbActiveModal} from "../../../../modules/modal/modal-ref";
import {PaymentDialogComponent} from "../../../../workspace/billing/payment-dialog/payment-dialog.component";
import * as fromStore from "../../../../store";
import {Payment} from "../../../../user/payment";
import {Subject} from "rxjs";
import {Store} from "@ngrx/store";
import {filter, first, switchMap} from "rxjs/operators";

@Component({
    selector: 'db-recharge',
    templateUrl: './recharge.component.html',
    styleUrls: ['./recharge.component.scss'],
    standalone: false
})
export class RechargeComponent implements OnInit {
  public UserSubscriptionType: any = UserSubscriptionType;
  public isMobile: boolean = false;
  public payments: Payment[];
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  @Input() userSubscription: UserSubscription;

  constructor(
    private readonly activeModal: DbActiveModal,
    private _router: Router,
    private _dialogService: DialogService,
    private _store: Store<fromStore.DbStoreState>,
  ) {
  }

  ngOnInit() {
    if ((Utils.checkDevice() && window.innerWidth <= 1024)) {
      this.isMobile = true;
    }
    this._getPayments();
  }

  public cancel(): void {
    this.activeModal.close();
  }

  private _getPayments() {
    this._store.select(fromStore.getPaymentsLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getPayments)),
        first()
      )
      .subscribe((payments: Payment[]) => {
        this.payments = payments ? payments.filter(payment => payment.paymentStatus === 'Confirmed') : [];
      });
  }


  public renewUserSubscription(renew: boolean = false): void {
    this.activeModal.close();
    this._dialogService
      .addDialog(PaymentDialogComponent, {
        upgradeSubscription: this.userSubscription,
        fromDialog: false,
        renew: true,
        activate: !renew,
        renewCouponCode: this.userSubscription && this.userSubscription.platformPaidClient && (!this.payments || this.payments.length === 0) && this.userSubscription.isExpired ? 'BLK50' : this.userSubscription && this.userSubscription.trialClient && this.userSubscription.isExpired ? 'BLK50OFF' : ''
      })
      .subscribe((reopenLast: boolean): void => {
        if (reopenLast) {
          this._store.dispatch(new fromStore.UpdateUserSubscription());
          this._store.dispatch(new fromStore.LoadUserLocalStorage());
          this._store.dispatch(new fromStore.LoadUserPayments());
        }
      });
  }

}
